export default __webpack_public_path__ + "3ee3522c243e046632463ae1b30560b4.png";